exports.i18nConfig = {
	enabled: true,
	langs: [
		'ru'
	],
	default: 'ru'
};
